<template>
  <main class="min-h-screen flex items-center justify-center py-4 sm:py-8 sm:p-8 bg-zinc-900">
    <div class="w-full max-w-md relative rounded-2xl bg-zinc-800/50 p-8 transition-all duration-300">
      <!-- Background gradient effect - changed to a more subtle blue/purple gradient -->
      <!-- <div class="absolute inset-0 -z-0 bg-gradient-to-br from-blue-500 to-purple-700 opacity-5"></div> -->
      
      <!-- Content -->
      <div class="relative z-10">
        <!-- Icon - changed to a more neutral color -->
        <div class="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-zinc-700/50">
          <ClockIcon class="h-10 w-10 text-blue-400" />
        </div>
        
        <!-- Title -->
        <h1 class="mb-3 text-center text-2xl font-bold text-white">Sessão Expirada</h1>
        
        <!-- Description -->
        <p class="mb-8 text-center text-zinc-400">
          Sua sessão expirou por inatividade. Por favor, faça login novamente para continuar utilizando o Bot Express.
        </p>
        
        <!-- Login button -->
        <button 
          @click="redirectToLogin" 
          class="w-full rounded-xl bg-emerald-500 py-3 px-4 text-center font-semibold text-black transition-colors hover:bg-emerald-400"
        >
          Fazer Login
        </button>
        
        <!-- Help link -->
        <div class="mt-6 text-center">
          <a href="https://wa.me/5561996213140" class="text-sm text-zinc-400 hover:text-zinc-300 transition-colors">
            Precisa de ajuda? Entre em contato com o suporte
          </a>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ClockIcon } from 'lucide-vue-next'

const redirectToLogin = () => {
  // Replace with your actual login route
  if (window.top) window.top.location.href = 'https://dashboard.hoopay.com.br/login.html'
}
</script>

<style scoped>

</style>